(() => {
  const DetailsModalElement = customElements.get('details-modal');

  if (!DetailsModalElement || customElements.get('heritage-search-modal')) return;

  class HeritageSearchModal extends DetailsModalElement {
    constructor() {
      super();
      this.closeTimer = null;
      this.focusTimer = null;
      this.closeTransitionHandler = null;
      this.motionDuration = 600;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileViewport = window.matchMedia('(max-width: 989px)');
      this.searchDrawer = this.detailsContainer.querySelector('.search-modal');
    }

    onBodyClick(event) {
      // The mobile backdrop is details::before, so its tap targets details itself.
      if (event.target === this.detailsContainer) {
        this.close();
        return;
      }
      super.onBodyClick(event);
    }

    open(event, coordinated = false) {
      if (this.mobileViewport.matches && !coordinated && window.heritageOpenDrawer) {
        return window.heritageOpenDrawer(this.detailsContainer, () => this.open(event, true));
      }
      window.clearTimeout(this.closeTimer);
      window.clearTimeout(this.focusTimer);

      if (this.closeTransitionHandler) {
        this.searchDrawer.removeEventListener('transitionend', this.closeTransitionHandler);
        this.closeTransitionHandler = null;
      }

      this.detailsContainer.classList.remove('is-closing');
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.detailsContainer.setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');

      const searchPanel = this.detailsContainer.querySelector('[tabindex="-1"]');
      const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
      const focusSearch = () => {
        if (!this.isOpen() || this.detailsContainer.classList.contains('is-closing')) return;

        trapFocus(searchPanel, this.mobileViewport.matches ? searchPanel : searchInput);
        this.focusTimer = null;
      };

      const startOpening = () => {
        if (!this.isOpen() || this.detailsContainer.classList.contains('is-closing')) return;

        this.detailsContainer.classList.add('search-opening');

        if (this.mobileViewport.matches) {
          this.focusTimer = window.setTimeout(focusSearch, this.motionDuration);
        } else {
          focusSearch();
        }
      };
      if (this.mobileViewport.matches) {
        // Match Styling Guide: paint the closed position before the slide and fade.
        window.requestAnimationFrame(() => window.requestAnimationFrame(startOpening));
      } else {
        window.requestAnimationFrame(startOpening);
      }
    }

    close(focusToggle = true) {
      window.heritageCancelDrawerOpen?.(this.detailsContainer);
      if (!this.isOpen() || this.detailsContainer.classList.contains('is-closing')) return;

      window.clearTimeout(this.focusTimer);
      this.focusTimer = null;
      let closeFinished = false;

      const finishClose = () => {
        if (closeFinished) return;

        closeFinished = true;
        window.clearTimeout(this.closeTimer);

        if (this.closeTransitionHandler) {
          this.searchDrawer.removeEventListener('transitionend', this.closeTransitionHandler);
          this.closeTransitionHandler = null;
        }

        this.detailsContainer.classList.remove('is-closing', 'search-opening');
        super.close(focusToggle);
        this.closeTimer = null;
      };

      if (this.mobileViewport.matches) {
        this.closeTransitionHandler = (event) => {
          if (event.target === this.searchDrawer && event.propertyName === 'transform') {
            finishClose();
          }
        };
        this.searchDrawer.addEventListener('transitionend', this.closeTransitionHandler);
      }

      this.detailsContainer.classList.add('is-closing');
      this.detailsContainer.classList.remove('search-opening');

      if (this.reduceMotion.matches && !this.mobileViewport.matches) {
        finishClose();
        return;
      }

      this.closeTimer = window.setTimeout(
        finishClose,
        this.mobileViewport.matches ? this.motionDuration + 100 : this.motionDuration
      );
    }

    disconnectedCallback() {
      window.heritageCancelDrawerOpen?.(this.detailsContainer);
      window.clearTimeout(this.closeTimer);
      window.clearTimeout(this.focusTimer);

      if (this.closeTransitionHandler) {
        this.searchDrawer.removeEventListener('transitionend', this.closeTransitionHandler);
      }
    }
  }

  customElements.define('heritage-search-modal', HeritageSearchModal);
})();
